import "@capacitor/core";
import * as $ from "react";
import { useRef as tt, useEffect as ee, useState as rt, useCallback as Dt } from "react";
const ka = (t) => {
  if (t.length < 12)
    throw new Error("Password must contain at least 12 characters");
  if (!/[A-Z]/.test(t))
    throw new Error(
      "Password must contain at least 1 uppercase character  (A..Z)"
    );
  if (!/\d/.test(t))
    throw new Error(
      "Password must contain at least 1 number character  (0..9)"
    );
  if (!/[!@#$%^&*()_+\-={}|[\];:,./<>?~`]/.test(t))
    throw new Error(
      "Password must contain at least 1 special character  (!@#$%^&*()_+-={}|[];:,./<>?~`)"
    );
  const n = t.match(
    /[^A-Za-z\d!@#$%^&*()_+\-={}|[\];:,./<>?~`]/g
  );
  if (n != null && n.length)
    throw new Error(
      `Password contains invalid characters ${n.map((r) => `(${r})`).join(", ")}`
    );
  return !0;
}, Ee = "body-wrapper", Ea = (t = Ee) => {
  var n;
  return ((n = document.getElementById(t)) == null ? void 0 : n.scrollTop) || 0;
}, Ua = (t) => {
  const n = document.getElementById(Ee);
  n && (n.scrollTop = t);
}, _a = (t, n = Ee, { includeElementHeight: r = !0, scrollOffset: a = 0 } = {}) => {
  const e = document.getElementById(n);
  if (e && e.scrollTo && t) {
    const o = t.offsetTop, i = r ? t.offsetHeight : 0, s = o + i + a;
    e.scrollTo({
      top: s,
      behavior: "smooth"
    });
  }
};
function Ya(t) {
  t.preventDefault(), t.stopPropagation(), t.nativeEvent.stopImmediatePropagation();
}
const Na = async (t, n) => {
  if (!navigator.clipboard) {
    n(new Error("Clipboard API not supported"));
    return;
  }
  try {
    await navigator.clipboard.writeText(window.location.href), t();
  } catch (r) {
    n(r);
  }
}, Ia = (t = "localStorage") => {
  const n = t === "sessionStorage" ? sessionStorage : localStorage;
  return {
    setItem: (o, i) => {
      n.setItem(o, JSON.stringify(i));
    },
    getItem: (o) => {
      try {
        const i = n.getItem(o);
        if (i)
          return JSON.parse(i);
      } catch {
      }
    },
    removeItem: (o) => {
      n.removeItem(o);
    },
    clear: n.clear
  };
}, Pt = (t, n) => n.sizeIdx < 2 ? 0 : n.sizeIdx === 2 ? t < 10 ? 1 : 0 : 1, Aa = (t, {
  precision: n = Pt,
  sizeTerms: r = ["bytes", "kb", "mb", "gb", "tb", "pb"],
  threshold: a = 1e3
} = {}) => {
  if (t === 0)
    return "";
  const e = Math.min(
    Math.floor(Math.log(t) / Math.log(a)),
    r.length - 1
  ), o = t / Math.pow(a, e), i = r[e], s = typeof n == "number" ? n : Array.isArray(n) ? n[e] || 0 : n(o, { threshold: a, bytes: t, sizeIdx: e, unit: i });
  return `${parseFloat(o.toFixed(s))} ${i}`;
}, Ct = "Something went wrong during submission.", Wa = (t, n = Ct) => {
  var r, a, e, o, i, s, u, c;
  if (t)
    return Array.isArray((a = (r = t == null ? void 0 : t.response) == null ? void 0 : r.data) == null ? void 0 : a.errors) ? (s = (i = (o = (e = t == null ? void 0 : t.response) == null ? void 0 : e.data) == null ? void 0 : o.errors) == null ? void 0 : i[0]) == null ? void 0 : s.message : typeof (t == null ? void 0 : t.message) == "string" ? t.message : typeof (t == null ? void 0 : t.error) == "string" ? t.error : typeof ((c = (u = t == null ? void 0 : t.errors) == null ? void 0 : u[0]) == null ? void 0 : c.message) == "string" ? t.errors[0].message : n;
};
function Ot(t) {
  return t ? t.charAt(0).toUpperCase() + t.slice(1) : "";
}
function La(t) {
  return t ? Ot(t).slice(0, t.length - 1) : "";
}
const $a = (t = "") => t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;"), Ha = (t) => t.replace(/(\r\n|\r|\n)/g, "<br/>"), Ra = (t) => t.split(/[\s+]/).map(
  (r) => `${(r[0] || "").toUpperCase()}${r.slice(1).toLowerCase()}`
).join("");
function qa(t) {
  return typeof t != "number" ? "" : `${(t / 1024).toFixed(2)} KB`;
}
const Fa = (t) => {
  const n = t.split("."), r = n.length > 1 ? n.pop() : void 0, a = n.join(".");
  return {
    fileName: t,
    baseName: a,
    extension: r
  };
};
function Sa(t, n) {
  return /^image\//i.test(n || "") || /\.(png|jpe?g)$/i.test(t || "");
}
function Qa(t, n) {
  return /\.csv$/i.test(t || "") || /^(text|application)\/csv(?:;|$)/i.test(n || "");
}
function kt(t, n) {
  const r = URL.createObjectURL(t), a = document.createElement("a");
  a.href = r, a.download = n, document.body.appendChild(a), a.click(), a.remove(), setTimeout(() => URL.revokeObjectURL(r), 6e4);
}
async function ja(t, n) {
  const r = await fetch(t);
  if (!r.ok) throw new Error("File download failed");
  kt(await r.blob(), n);
}
const Et = /^(token|access_token|auth_token)$/i, Ut = /^(x-amz-.*|signature|key-pair-id|awsaccesskeyid)$/i, _t = /^(.*\/vault\/files\/redirect)\/.+$/, Se = "https://relative.invalid", Ba = (t) => {
  let n;
  try {
    n = new URL(t, Se);
  } catch {
    return t;
  }
  const r = n.origin === Se ? "" : n.origin, a = Array.from(n.searchParams.keys());
  if (a.some((o) => Ut.test(o)))
    return `${r}/[Filtered]`;
  const e = n.pathname.match(_t);
  return e ? `${r}${e[1]}/[Filtered]` : a.some((o) => Et.test(o)) ? `${r}${n.pathname}` : t;
}, Xa = (t) => {
  const n = t.includes("\\n"), r = t.includes(`
`), a = t.includes("</div>") && t.includes("<div>") && !t.includes("\\n") && !t.includes(`
`);
  return !n && !r || a ? t : t.replace(/<[^>]*>/g, "").replace(/\\n/g, `
`).split(/\r\n|\r|\n/).map((i) => i.trim() ? `<div>${i}</div>` : "<div></div>").join("");
}, Ga = (t, n) => n > 0 ? Math.floor(t * 100 / n) : 0, za = (t) => `${Math.floor(t ?? 0)}%`, Yt = (t, n = "") => {
  const r = Number(t);
  return !Number.isFinite(r) || t === "" || t === null || t === void 0 ? n : r.toLocaleString("en-US", {
    style: "currency",
    currency: "USD"
  });
}, Va = (t, n) => {
  const a = parseInt(t) / 100;
  return Yt(a, n);
};
function j(t) {
  "@babel/helpers - typeof";
  return j = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, j(t);
}
function W(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var n = Number(t);
  return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
}
function M(t, n) {
  if (n.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + n.length + " present");
}
function b(t) {
  M(1, arguments);
  var n = Object.prototype.toString.call(t);
  return t instanceof Date || j(t) === "object" && n === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || n === "[object Number]" ? new Date(t) : ((typeof t == "string" || n === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Nt(t, n) {
  M(2, arguments);
  var r = b(t).getTime(), a = W(n);
  return new Date(r + a);
}
var It = {};
function re() {
  return It;
}
function pe(t) {
  var n = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return n.setUTCFullYear(t.getFullYear()), t.getTime() - n.getTime();
}
function he(t, n) {
  M(2, arguments);
  var r = b(t), a = b(n), e = r.getTime() - a.getTime();
  return e < 0 ? -1 : e > 0 ? 1 : e;
}
var At = 6e4, Wt = 36e5, Lt = 1e3;
function $t(t) {
  return M(1, arguments), t instanceof Date || j(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Ht(t) {
  if (M(1, arguments), !$t(t) && typeof t != "number")
    return !1;
  var n = b(t);
  return !isNaN(Number(n));
}
function Rt(t, n) {
  M(2, arguments);
  var r = b(t), a = b(n), e = r.getFullYear() - a.getFullYear(), o = r.getMonth() - a.getMonth();
  return e * 12 + o;
}
function qt(t, n) {
  return M(2, arguments), b(t).getTime() - b(n).getTime();
}
var Qe = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(n) {
    return n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  // Math.trunc is not supported by IE
}, Ft = "trunc";
function St(t) {
  return t ? Qe[t] : Qe[Ft];
}
function Qt(t) {
  M(1, arguments);
  var n = b(t);
  return n.setHours(23, 59, 59, 999), n;
}
function jt(t) {
  M(1, arguments);
  var n = b(t), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Bt(t) {
  M(1, arguments);
  var n = b(t);
  return Qt(n).getTime() === jt(n).getTime();
}
function Xt(t, n) {
  M(2, arguments);
  var r = b(t), a = b(n), e = he(r, a), o = Math.abs(Rt(r, a)), i;
  if (o < 1)
    i = 0;
  else {
    r.getMonth() === 1 && r.getDate() > 27 && r.setDate(30), r.setMonth(r.getMonth() - e * o);
    var s = he(r, a) === -e;
    Bt(b(t)) && o === 1 && he(t, a) === 1 && (s = !1), i = e * (o - Number(s));
  }
  return i === 0 ? 0 : i;
}
function Gt(t, n, r) {
  M(2, arguments);
  var a = qt(t, n) / 1e3;
  return St(void 0)(a);
}
function nt(t, n) {
  M(2, arguments);
  var r = W(n);
  return Nt(t, -r);
}
var zt = 864e5;
function Vt(t) {
  M(1, arguments);
  var n = b(t), r = n.getTime();
  n.setUTCMonth(0, 1), n.setUTCHours(0, 0, 0, 0);
  var a = n.getTime(), e = r - a;
  return Math.floor(e / zt) + 1;
}
function ie(t) {
  M(1, arguments);
  var n = 1, r = b(t), a = r.getUTCDay(), e = (a < n ? 7 : 0) + a - n;
  return r.setUTCDate(r.getUTCDate() - e), r.setUTCHours(0, 0, 0, 0), r;
}
function at(t) {
  M(1, arguments);
  var n = b(t), r = n.getUTCFullYear(), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(r + 1, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var e = ie(a), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(r, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var i = ie(o);
  return n.getTime() >= e.getTime() ? r + 1 : n.getTime() >= i.getTime() ? r : r - 1;
}
function Kt(t) {
  M(1, arguments);
  var n = at(t), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = ie(r);
  return a;
}
var Zt = 6048e5;
function it(t) {
  M(1, arguments);
  var n = b(t), r = ie(n).getTime() - Kt(n).getTime();
  return Math.round(r / Zt) + 1;
}
function te(t, n) {
  var r, a, e, o, i, s, u, c;
  M(1, arguments);
  var v = re(), d = W((r = (a = (e = (o = n == null ? void 0 : n.weekStartsOn) !== null && o !== void 0 ? o : n == null || (i = n.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && e !== void 0 ? e : v.weekStartsOn) !== null && a !== void 0 ? a : (u = v.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = b(t), m = h.getUTCDay(), D = (m < d ? 7 : 0) + m - d;
  return h.setUTCDate(h.getUTCDate() - D), h.setUTCHours(0, 0, 0, 0), h;
}
function Ue(t, n) {
  var r, a, e, o, i, s, u, c;
  M(1, arguments);
  var v = b(t), d = v.getUTCFullYear(), h = re(), m = W((r = (a = (e = (o = n == null ? void 0 : n.firstWeekContainsDate) !== null && o !== void 0 ? o : n == null || (i = n.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && e !== void 0 ? e : h.firstWeekContainsDate) !== null && a !== void 0 ? a : (u = h.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(m >= 1 && m <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var D = /* @__PURE__ */ new Date(0);
  D.setUTCFullYear(d + 1, 0, m), D.setUTCHours(0, 0, 0, 0);
  var I = te(D, n), N = /* @__PURE__ */ new Date(0);
  N.setUTCFullYear(d, 0, m), N.setUTCHours(0, 0, 0, 0);
  var R = te(N, n);
  return v.getTime() >= I.getTime() ? d + 1 : v.getTime() >= R.getTime() ? d : d - 1;
}
function Jt(t, n) {
  var r, a, e, o, i, s, u, c;
  M(1, arguments);
  var v = re(), d = W((r = (a = (e = (o = n == null ? void 0 : n.firstWeekContainsDate) !== null && o !== void 0 ? o : n == null || (i = n.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && e !== void 0 ? e : v.firstWeekContainsDate) !== null && a !== void 0 ? a : (u = v.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), h = Ue(t, n), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(h, 0, d), m.setUTCHours(0, 0, 0, 0);
  var D = te(m, n);
  return D;
}
var er = 6048e5;
function ot(t, n) {
  M(1, arguments);
  var r = b(t), a = te(r, n).getTime() - Jt(r, n).getTime();
  return Math.round(a / er) + 1;
}
function x(t, n) {
  for (var r = t < 0 ? "-" : "", a = Math.abs(t).toString(); a.length < n; )
    a = "0" + a;
  return r + a;
}
var z = {
  // Year
  y: function(n, r) {
    var a = n.getUTCFullYear(), e = a > 0 ? a : 1 - a;
    return x(r === "yy" ? e % 100 : e, r.length);
  },
  // Month
  M: function(n, r) {
    var a = n.getUTCMonth();
    return r === "M" ? String(a + 1) : x(a + 1, 2);
  },
  // Day of the month
  d: function(n, r) {
    return x(n.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(n, r) {
    var a = n.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return a.toUpperCase();
      case "aaa":
        return a;
      case "aaaaa":
        return a[0];
      case "aaaa":
      default:
        return a === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(n, r) {
    return x(n.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(n, r) {
    return x(n.getUTCHours(), r.length);
  },
  // Minute
  m: function(n, r) {
    return x(n.getUTCMinutes(), r.length);
  },
  // Second
  s: function(n, r) {
    return x(n.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(n, r) {
    var a = r.length, e = n.getUTCMilliseconds(), o = Math.floor(e * Math.pow(10, a - 3));
    return x(o, r.length);
  }
}, ne = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, tr = {
  // Era
  G: function(n, r, a) {
    var e = n.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(e, {
          width: "abbreviated"
        });
      case "GGGGG":
        return a.era(e, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return a.era(e, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(n, r, a) {
    if (r === "yo") {
      var e = n.getUTCFullYear(), o = e > 0 ? e : 1 - e;
      return a.ordinalNumber(o, {
        unit: "year"
      });
    }
    return z.y(n, r);
  },
  // Local week-numbering year
  Y: function(n, r, a, e) {
    var o = Ue(n, e), i = o > 0 ? o : 1 - o;
    if (r === "YY") {
      var s = i % 100;
      return x(s, 2);
    }
    return r === "Yo" ? a.ordinalNumber(i, {
      unit: "year"
    }) : x(i, r.length);
  },
  // ISO week-numbering year
  R: function(n, r) {
    var a = at(n);
    return x(a, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, r) {
    var a = n.getUTCFullYear();
    return x(a, r.length);
  },
  // Quarter
  Q: function(n, r, a) {
    var e = Math.ceil((n.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(e);
      case "QQ":
        return x(e, 2);
      case "Qo":
        return a.ordinalNumber(e, {
          unit: "quarter"
        });
      case "QQQ":
        return a.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, r, a) {
    var e = Math.ceil((n.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(e);
      case "qq":
        return x(e, 2);
      case "qo":
        return a.ordinalNumber(e, {
          unit: "quarter"
        });
      case "qqq":
        return a.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(e, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, r, a) {
    var e = n.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return z.M(n, r);
      case "Mo":
        return a.ordinalNumber(e + 1, {
          unit: "month"
        });
      case "MMM":
        return a.month(e, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return a.month(e, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(n, r, a) {
    var e = n.getUTCMonth();
    switch (r) {
      case "L":
        return String(e + 1);
      case "LL":
        return x(e + 1, 2);
      case "Lo":
        return a.ordinalNumber(e + 1, {
          unit: "month"
        });
      case "LLL":
        return a.month(e, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return a.month(e, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(e, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(n, r, a, e) {
    var o = ot(n, e);
    return r === "wo" ? a.ordinalNumber(o, {
      unit: "week"
    }) : x(o, r.length);
  },
  // ISO week of year
  I: function(n, r, a) {
    var e = it(n);
    return r === "Io" ? a.ordinalNumber(e, {
      unit: "week"
    }) : x(e, r.length);
  },
  // Day of the month
  d: function(n, r, a) {
    return r === "do" ? a.ordinalNumber(n.getUTCDate(), {
      unit: "date"
    }) : z.d(n, r);
  },
  // Day of year
  D: function(n, r, a) {
    var e = Vt(n);
    return r === "Do" ? a.ordinalNumber(e, {
      unit: "dayOfYear"
    }) : x(e, r.length);
  },
  // Day of week
  E: function(n, r, a) {
    var e = n.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(e, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return a.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(e, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return a.day(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, r, a, e) {
    var o = n.getUTCDay(), i = (o - e.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(i);
      case "ee":
        return x(i, 2);
      case "eo":
        return a.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return a.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return a.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return a.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, r, a, e) {
    var o = n.getUTCDay(), i = (o - e.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(i);
      case "cc":
        return x(i, r.length);
      case "co":
        return a.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return a.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return a.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return a.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, r, a) {
    var e = n.getUTCDay(), o = e === 0 ? 7 : e;
    switch (r) {
      case "i":
        return String(o);
      case "ii":
        return x(o, r.length);
      case "io":
        return a.ordinalNumber(o, {
          unit: "day"
        });
      case "iii":
        return a.day(e, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return a.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return a.day(e, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return a.day(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, r, a) {
    var e = n.getUTCHours(), o = e / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return a.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return a.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return a.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, r, a) {
    var e = n.getUTCHours(), o;
    switch (e === 12 ? o = ne.noon : e === 0 ? o = ne.midnight : o = e / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return a.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return a.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return a.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, r, a) {
    var e = n.getUTCHours(), o;
    switch (e >= 17 ? o = ne.evening : e >= 12 ? o = ne.afternoon : e >= 4 ? o = ne.morning : o = ne.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, r, a) {
    if (r === "ho") {
      var e = n.getUTCHours() % 12;
      return e === 0 && (e = 12), a.ordinalNumber(e, {
        unit: "hour"
      });
    }
    return z.h(n, r);
  },
  // Hour [0-23]
  H: function(n, r, a) {
    return r === "Ho" ? a.ordinalNumber(n.getUTCHours(), {
      unit: "hour"
    }) : z.H(n, r);
  },
  // Hour [0-11]
  K: function(n, r, a) {
    var e = n.getUTCHours() % 12;
    return r === "Ko" ? a.ordinalNumber(e, {
      unit: "hour"
    }) : x(e, r.length);
  },
  // Hour [1-24]
  k: function(n, r, a) {
    var e = n.getUTCHours();
    return e === 0 && (e = 24), r === "ko" ? a.ordinalNumber(e, {
      unit: "hour"
    }) : x(e, r.length);
  },
  // Minute
  m: function(n, r, a) {
    return r === "mo" ? a.ordinalNumber(n.getUTCMinutes(), {
      unit: "minute"
    }) : z.m(n, r);
  },
  // Second
  s: function(n, r, a) {
    return r === "so" ? a.ordinalNumber(n.getUTCSeconds(), {
      unit: "second"
    }) : z.s(n, r);
  },
  // Fraction of second
  S: function(n, r) {
    return z.S(n, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, r, a, e) {
    var o = e._originalDate || n, i = o.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (r) {
      case "X":
        return Be(i);
      case "XXXX":
      case "XX":
        return J(i);
      case "XXXXX":
      case "XXX":
      default:
        return J(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, r, a, e) {
    var o = e._originalDate || n, i = o.getTimezoneOffset();
    switch (r) {
      case "x":
        return Be(i);
      case "xxxx":
      case "xx":
        return J(i);
      case "xxxxx":
      case "xxx":
      default:
        return J(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, r, a, e) {
    var o = e._originalDate || n, i = o.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + je(i, ":");
      case "OOOO":
      default:
        return "GMT" + J(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, r, a, e) {
    var o = e._originalDate || n, i = o.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + je(i, ":");
      case "zzzz":
      default:
        return "GMT" + J(i, ":");
    }
  },
  // Seconds timestamp
  t: function(n, r, a, e) {
    var o = e._originalDate || n, i = Math.floor(o.getTime() / 1e3);
    return x(i, r.length);
  },
  // Milliseconds timestamp
  T: function(n, r, a, e) {
    var o = e._originalDate || n, i = o.getTime();
    return x(i, r.length);
  }
};
function je(t, n) {
  var r = t > 0 ? "-" : "+", a = Math.abs(t), e = Math.floor(a / 60), o = a % 60;
  if (o === 0)
    return r + String(e);
  var i = n;
  return r + String(e) + i + x(o, 2);
}
function Be(t, n) {
  if (t % 60 === 0) {
    var r = t > 0 ? "-" : "+";
    return r + x(Math.abs(t) / 60, 2);
  }
  return J(t, n);
}
function J(t, n) {
  var r = n || "", a = t > 0 ? "-" : "+", e = Math.abs(t), o = x(Math.floor(e / 60), 2), i = x(e % 60, 2);
  return a + o + r + i;
}
var Xe = function(n, r) {
  switch (n) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, st = function(n, r) {
  switch (n) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, rr = function(n, r) {
  var a = n.match(/(P+)(p+)?/) || [], e = a[1], o = a[2];
  if (!o)
    return Xe(n, r);
  var i;
  switch (e) {
    case "P":
      i = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = r.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", Xe(e, r)).replace("{{time}}", st(o, r));
}, Pe = {
  p: st,
  P: rr
}, nr = ["D", "DD"], ar = ["YY", "YYYY"];
function ut(t) {
  return nr.indexOf(t) !== -1;
}
function ct(t) {
  return ar.indexOf(t) !== -1;
}
function we(t, n, r) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(n, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(n, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(n, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(n, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var ir = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, lt = function(n, r, a) {
  var e, o = ir[n];
  return typeof o == "string" ? e = o : r === 1 ? e = o.one : e = o.other.replace("{{count}}", r.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "in " + e : e + " ago" : e;
};
function ae(t) {
  return function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = n.width ? String(n.width) : t.defaultWidth, a = t.formats[r] || t.formats[t.defaultWidth];
    return a;
  };
}
var or = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, sr = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ur = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, cr = {
  date: ae({
    formats: or,
    defaultWidth: "full"
  }),
  time: ae({
    formats: sr,
    defaultWidth: "full"
  }),
  dateTime: ae({
    formats: ur,
    defaultWidth: "full"
  })
}, lr = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ft = function(n, r, a, e) {
  return lr[n];
};
function le(t) {
  return function(n, r) {
    var a = r != null && r.context ? String(r.context) : "standalone", e;
    if (a === "formatting" && t.formattingValues) {
      var o = t.defaultFormattingWidth || t.defaultWidth, i = r != null && r.width ? String(r.width) : o;
      e = t.formattingValues[i] || t.formattingValues[o];
    } else {
      var s = t.defaultWidth, u = r != null && r.width ? String(r.width) : t.defaultWidth;
      e = t.values[u] || t.values[s];
    }
    var c = t.argumentCallback ? t.argumentCallback(n) : n;
    return e[c];
  };
}
var fr = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, dr = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, vr = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, mr = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, hr = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, pr = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, wr = function(n, r) {
  var a = Number(n), e = a % 100;
  if (e > 20 || e < 10)
    switch (e % 10) {
      case 1:
        return a + "st";
      case 2:
        return a + "nd";
      case 3:
        return a + "rd";
    }
  return a + "th";
}, dt = {
  ordinalNumber: wr,
  era: le({
    values: fr,
    defaultWidth: "wide"
  }),
  quarter: le({
    values: dr,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: le({
    values: vr,
    defaultWidth: "wide"
  }),
  day: le({
    values: mr,
    defaultWidth: "wide"
  }),
  dayPeriod: le({
    values: hr,
    defaultWidth: "wide",
    formattingValues: pr,
    defaultFormattingWidth: "wide"
  })
};
function fe(t) {
  return function(n) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.width, e = a && t.matchPatterns[a] || t.matchPatterns[t.defaultMatchWidth], o = n.match(e);
    if (!o)
      return null;
    var i = o[0], s = a && t.parsePatterns[a] || t.parsePatterns[t.defaultParseWidth], u = Array.isArray(s) ? yr(s, function(d) {
      return d.test(i);
    }) : gr(s, function(d) {
      return d.test(i);
    }), c;
    c = t.valueCallback ? t.valueCallback(u) : u, c = r.valueCallback ? r.valueCallback(c) : c;
    var v = n.slice(i.length);
    return {
      value: c,
      rest: v
    };
  };
}
function gr(t, n) {
  for (var r in t)
    if (t.hasOwnProperty(r) && n(t[r]))
      return r;
}
function yr(t, n) {
  for (var r = 0; r < t.length; r++)
    if (n(t[r]))
      return r;
}
function br(t) {
  return function(n) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.match(t.matchPattern);
    if (!a) return null;
    var e = a[0], o = n.match(t.parsePattern);
    if (!o) return null;
    var i = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    i = r.valueCallback ? r.valueCallback(i) : i;
    var s = n.slice(e.length);
    return {
      value: i,
      rest: s
    };
  };
}
var Tr = /^(\d+)(th|st|nd|rd)?/i, xr = /\d+/i, Mr = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Dr = {
  any: [/^b/i, /^(a|c)/i]
}, Pr = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Cr = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Or = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, kr = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Er = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Ur = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, _r = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Yr = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, vt = {
  ordinalNumber: br({
    matchPattern: Tr,
    parsePattern: xr,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: fe({
    matchPatterns: Mr,
    defaultMatchWidth: "wide",
    parsePatterns: Dr,
    defaultParseWidth: "any"
  }),
  quarter: fe({
    matchPatterns: Pr,
    defaultMatchWidth: "wide",
    parsePatterns: Cr,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: fe({
    matchPatterns: Or,
    defaultMatchWidth: "wide",
    parsePatterns: kr,
    defaultParseWidth: "any"
  }),
  day: fe({
    matchPatterns: Er,
    defaultMatchWidth: "wide",
    parsePatterns: Ur,
    defaultParseWidth: "any"
  }),
  dayPeriod: fe({
    matchPatterns: _r,
    defaultMatchWidth: "any",
    parsePatterns: Yr,
    defaultParseWidth: "any"
  })
}, _e = {
  code: "en-US",
  formatDistance: lt,
  formatLong: cr,
  formatRelative: ft,
  localize: dt,
  match: vt,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Nr = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ir = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ar = /^'([^]*?)'?$/, Wr = /''/g, Lr = /[a-zA-Z]/;
function Ye(t, n, r) {
  var a, e, o, i, s, u, c, v, d, h, m, D, I, N;
  M(2, arguments);
  var R = String(n), U = re(), A = (a = (e = void 0) !== null && e !== void 0 ? e : U.locale) !== null && a !== void 0 ? a : _e, S = W((o = (i = (s = (u = void 0) !== null && u !== void 0 ? u : void 0) !== null && s !== void 0 ? s : U.firstWeekContainsDate) !== null && i !== void 0 ? i : (c = U.locale) === null || c === void 0 || (v = c.options) === null || v === void 0 ? void 0 : v.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(S >= 1 && S <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var X = W((d = (h = (m = (D = void 0) !== null && D !== void 0 ? D : void 0) !== null && m !== void 0 ? m : U.weekStartsOn) !== null && h !== void 0 ? h : (I = U.locale) === null || I === void 0 || (N = I.options) === null || N === void 0 ? void 0 : N.weekStartsOn) !== null && d !== void 0 ? d : 0);
  if (!(X >= 0 && X <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!A.localize)
    throw new RangeError("locale must contain localize property");
  if (!A.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var G = b(t);
  if (!Ht(G))
    throw new RangeError("Invalid time value");
  var oe = pe(G), se = nt(G, oe), ue = {
    firstWeekContainsDate: S,
    weekStartsOn: X,
    locale: A,
    _originalDate: G
  }, Te = R.match(Ir).map(function(Y) {
    var L = Y[0];
    if (L === "p" || L === "P") {
      var Z = Pe[L];
      return Z(Y, A.formatLong);
    }
    return Y;
  }).join("").match(Nr).map(function(Y) {
    if (Y === "''")
      return "'";
    var L = Y[0];
    if (L === "'")
      return $r(Y);
    var Z = tr[L];
    if (Z)
      return ct(Y) && we(Y, n, String(t)), ut(Y) && we(Y, n, String(t)), Z(se, Y, A.localize, ue);
    if (L.match(Lr))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + L + "`");
    return Y;
  }).join("");
  return Te;
}
function $r(t) {
  var n = t.match(Ar);
  return n ? n[1].replace(Wr, "'") : t;
}
function Ne(t, n) {
  if (t == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var r in n)
    Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  return t;
}
function Hr(t) {
  return Ne({}, t);
}
var Ge = 1440, Rr = 2520, De = 43200, qr = 86400;
function Fr(t, n, r) {
  var a, e;
  M(2, arguments);
  var o = re(), i = (a = (e = r == null ? void 0 : r.locale) !== null && e !== void 0 ? e : o.locale) !== null && a !== void 0 ? a : _e;
  if (!i.formatDistance)
    throw new RangeError("locale must contain formatDistance property");
  var s = he(t, n);
  if (isNaN(s))
    throw new RangeError("Invalid time value");
  var u = Ne(Hr(r), {
    addSuffix: !!(r != null && r.addSuffix),
    comparison: s
  }), c, v;
  s > 0 ? (c = b(n), v = b(t)) : (c = b(t), v = b(n));
  var d = Gt(v, c), h = (pe(v) - pe(c)) / 1e3, m = Math.round((d - h) / 60), D;
  if (m < 2)
    return r != null && r.includeSeconds ? d < 5 ? i.formatDistance("lessThanXSeconds", 5, u) : d < 10 ? i.formatDistance("lessThanXSeconds", 10, u) : d < 20 ? i.formatDistance("lessThanXSeconds", 20, u) : d < 40 ? i.formatDistance("halfAMinute", 0, u) : d < 60 ? i.formatDistance("lessThanXMinutes", 1, u) : i.formatDistance("xMinutes", 1, u) : m === 0 ? i.formatDistance("lessThanXMinutes", 1, u) : i.formatDistance("xMinutes", m, u);
  if (m < 45)
    return i.formatDistance("xMinutes", m, u);
  if (m < 90)
    return i.formatDistance("aboutXHours", 1, u);
  if (m < Ge) {
    var I = Math.round(m / 60);
    return i.formatDistance("aboutXHours", I, u);
  } else {
    if (m < Rr)
      return i.formatDistance("xDays", 1, u);
    if (m < De) {
      var N = Math.round(m / Ge);
      return i.formatDistance("xDays", N, u);
    } else if (m < qr)
      return D = Math.round(m / De), i.formatDistance("aboutXMonths", D, u);
  }
  if (D = Xt(v, c), D < 12) {
    var R = Math.round(m / De);
    return i.formatDistance("xMonths", R, u);
  } else {
    var U = D % 12, A = Math.floor(D / 12);
    return U < 3 ? i.formatDistance("aboutXYears", A, u) : U < 9 ? i.formatDistance("overXYears", A, u) : i.formatDistance("almostXYears", A + 1, u);
  }
}
function ze(t, n) {
  (n == null || n > t.length) && (n = t.length);
  for (var r = 0, a = Array(n); r < n; r++) a[r] = t[r];
  return a;
}
function Sr(t, n) {
  if (t) {
    if (typeof t == "string") return ze(t, n);
    var r = {}.toString.call(t).slice(8, -1);
    return r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set" ? Array.from(t) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ze(t, n) : void 0;
  }
}
function Ve(t, n) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!r) {
    if (Array.isArray(t) || (r = Sr(t)) || n) {
      r && (t = r);
      var a = 0, e = function() {
      };
      return {
        s: e,
        n: function() {
          return a >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[a++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: e
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o, i = !0, s = !1;
  return {
    s: function() {
      r = r.call(t);
    },
    n: function() {
      var c = r.next();
      return i = c.done, c;
    },
    e: function(c) {
      s = !0, o = c;
    },
    f: function() {
      try {
        i || r.return == null || r.return();
      } finally {
        if (s) throw o;
      }
    }
  };
}
function f(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Ce(t, n) {
  return Ce = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, Ce(t, n);
}
function g(t, n) {
  if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), n && Ce(t, n);
}
function ge(t) {
  return ge = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ge(t);
}
function mt() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (mt = function() {
    return !!t;
  })();
}
function Qr(t, n) {
  if (n && (j(n) == "object" || typeof n == "function")) return n;
  if (n !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return f(t);
}
function y(t) {
  var n = mt();
  return function() {
    var r, a = ge(t);
    if (n) {
      var e = ge(this).constructor;
      r = Reflect.construct(a, arguments, e);
    } else r = a.apply(this, arguments);
    return Qr(this, r);
  };
}
function p(t, n) {
  if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function jr(t, n) {
  if (j(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var a = r.call(t, n || "default");
    if (j(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(t);
}
function ht(t) {
  var n = jr(t, "string");
  return j(n) == "symbol" ? n : n + "";
}
function Br(t, n) {
  for (var r = 0; r < n.length; r++) {
    var a = n[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, ht(a.key), a);
  }
}
function w(t, n, r) {
  return n && Br(t.prototype, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function l(t, n, r) {
  return (n = ht(n)) in t ? Object.defineProperty(t, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[n] = r, t;
}
var Xr = 10, pt = /* @__PURE__ */ function() {
  function t() {
    p(this, t), l(this, "priority", void 0), l(this, "subPriority", 0);
  }
  return w(t, [{
    key: "validate",
    value: function(r, a) {
      return !0;
    }
  }]), t;
}(), Gr = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r(a, e, o, i, s) {
    var u;
    return p(this, r), u = n.call(this), u.value = a, u.validateValue = e, u.setValue = o, u.priority = i, s && (u.subPriority = s), u;
  }
  return w(r, [{
    key: "validate",
    value: function(e, o) {
      return this.validateValue(e, this.value, o);
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return this.setValue(e, o, this.value, i);
    }
  }]), r;
}(pt), zr = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", Xr), l(f(a), "subPriority", -1), a;
  }
  return w(r, [{
    key: "set",
    value: function(e, o) {
      if (o.timestampIsSet)
        return e;
      var i = /* @__PURE__ */ new Date(0);
      return i.setFullYear(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()), i.setHours(e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()), i;
    }
  }]), r;
}(pt), T = /* @__PURE__ */ function() {
  function t() {
    p(this, t), l(this, "incompatibleTokens", void 0), l(this, "priority", void 0), l(this, "subPriority", void 0);
  }
  return w(t, [{
    key: "run",
    value: function(r, a, e, o) {
      var i = this.parse(r, a, e, o);
      return i ? {
        setter: new Gr(i.value, this.validate, this.set, this.priority, this.subPriority),
        rest: i.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(r, a, e) {
      return !0;
    }
  }]), t;
}(), Vr = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 140), l(f(a), "incompatibleTokens", ["R", "u", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "G":
        case "GG":
        case "GGG":
          return i.era(e, {
            width: "abbreviated"
          }) || i.era(e, {
            width: "narrow"
          });
        case "GGGGG":
          return i.era(e, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return i.era(e, {
            width: "wide"
          }) || i.era(e, {
            width: "abbreviated"
          }) || i.era(e, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return o.era = i, e.setUTCFullYear(i, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), k = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, q = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function E(t, n) {
  return t && {
    value: n(t.value),
    rest: t.rest
  };
}
function C(t, n) {
  var r = n.match(t);
  return r ? {
    value: parseInt(r[0], 10),
    rest: n.slice(r[0].length)
  } : null;
}
function F(t, n) {
  var r = n.match(t);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  var a = r[1] === "+" ? 1 : -1, e = r[2] ? parseInt(r[2], 10) : 0, o = r[3] ? parseInt(r[3], 10) : 0, i = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: a * (e * Wt + o * At + i * Lt),
    rest: n.slice(r[0].length)
  };
}
function wt(t) {
  return C(k.anyDigitsSigned, t);
}
function O(t, n) {
  switch (t) {
    case 1:
      return C(k.singleDigit, n);
    case 2:
      return C(k.twoDigits, n);
    case 3:
      return C(k.threeDigits, n);
    case 4:
      return C(k.fourDigits, n);
    default:
      return C(new RegExp("^\\d{1," + t + "}"), n);
  }
}
function ye(t, n) {
  switch (t) {
    case 1:
      return C(k.singleDigitSigned, n);
    case 2:
      return C(k.twoDigitsSigned, n);
    case 3:
      return C(k.threeDigitsSigned, n);
    case 4:
      return C(k.fourDigitsSigned, n);
    default:
      return C(new RegExp("^-?\\d{1," + t + "}"), n);
  }
}
function Ie(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function gt(t, n) {
  var r = n > 0, a = r ? n : 1 - n, e;
  if (a <= 50)
    e = t || 100;
  else {
    var o = a + 50, i = Math.floor(o / 100) * 100, s = t >= o % 100;
    e = t + i - (s ? 100 : 0);
  }
  return r ? e : 1 - e;
}
function yt(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
var Kr = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 130), l(f(a), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      var s = function(c) {
        return {
          year: c,
          isTwoDigitYear: o === "yy"
        };
      };
      switch (o) {
        case "y":
          return E(O(4, e), s);
        case "yo":
          return E(i.ordinalNumber(e, {
            unit: "year"
          }), s);
        default:
          return E(O(o.length, e), s);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o.isTwoDigitYear || o.year > 0;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      var s = e.getUTCFullYear();
      if (i.isTwoDigitYear) {
        var u = gt(i.year, s);
        return e.setUTCFullYear(u, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
      }
      var c = !("era" in o) || o.era === 1 ? i.year : 1 - i.year;
      return e.setUTCFullYear(c, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), Zr = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 130), l(f(a), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      var s = function(c) {
        return {
          year: c,
          isTwoDigitYear: o === "YY"
        };
      };
      switch (o) {
        case "Y":
          return E(O(4, e), s);
        case "Yo":
          return E(i.ordinalNumber(e, {
            unit: "year"
          }), s);
        default:
          return E(O(o.length, e), s);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o.isTwoDigitYear || o.year > 0;
    }
  }, {
    key: "set",
    value: function(e, o, i, s) {
      var u = Ue(e, s);
      if (i.isTwoDigitYear) {
        var c = gt(i.year, u);
        return e.setUTCFullYear(c, 0, s.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), te(e, s);
      }
      var v = !("era" in o) || o.era === 1 ? i.year : 1 - i.year;
      return e.setUTCFullYear(v, 0, s.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), te(e, s);
    }
  }]), r;
}(T), Jr = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 130), l(f(a), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o) {
      return ye(o === "R" ? 4 : o.length, e);
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(i, 0, 4), s.setUTCHours(0, 0, 0, 0), ie(s);
    }
  }]), r;
}(T), en = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 130), l(f(a), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o) {
      return ye(o === "u" ? 4 : o.length, e);
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCFullYear(i, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), tn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 120), l(f(a), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "Q":
        case "QQ":
          return O(o.length, e);
        case "Qo":
          return i.ordinalNumber(e, {
            unit: "quarter"
          });
        case "QQQ":
          return i.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return i.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return i.quarter(e, {
            width: "wide",
            context: "formatting"
          }) || i.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 1 && o <= 4;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCMonth((i - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), rn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 120), l(f(a), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "q":
        case "qq":
          return O(o.length, e);
        case "qo":
          return i.ordinalNumber(e, {
            unit: "quarter"
          });
        case "qqq":
          return i.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return i.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return i.quarter(e, {
            width: "wide",
            context: "standalone"
          }) || i.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 1 && o <= 4;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCMonth((i - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), nn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), l(f(a), "priority", 110), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      var s = function(c) {
        return c - 1;
      };
      switch (o) {
        case "M":
          return E(C(k.month, e), s);
        case "MM":
          return E(O(2, e), s);
        case "Mo":
          return E(i.ordinalNumber(e, {
            unit: "month"
          }), s);
        case "MMM":
          return i.month(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(e, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return i.month(e, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return i.month(e, {
            width: "wide",
            context: "formatting"
          }) || i.month(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 11;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCMonth(i, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), an = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 110), l(f(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      var s = function(c) {
        return c - 1;
      };
      switch (o) {
        case "L":
          return E(C(k.month, e), s);
        case "LL":
          return E(O(2, e), s);
        case "Lo":
          return E(i.ordinalNumber(e, {
            unit: "month"
          }), s);
        case "LLL":
          return i.month(e, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(e, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return i.month(e, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return i.month(e, {
            width: "wide",
            context: "standalone"
          }) || i.month(e, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 11;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCMonth(i, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T);
function on(t, n, r) {
  M(2, arguments);
  var a = b(t), e = W(n), o = ot(a, r) - e;
  return a.setUTCDate(a.getUTCDate() - o * 7), a;
}
var sn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 100), l(f(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "w":
          return C(k.week, e);
        case "wo":
          return i.ordinalNumber(e, {
            unit: "week"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 1 && o <= 53;
    }
  }, {
    key: "set",
    value: function(e, o, i, s) {
      return te(on(e, i, s), s);
    }
  }]), r;
}(T);
function un(t, n) {
  M(2, arguments);
  var r = b(t), a = W(n), e = it(r) - a;
  return r.setUTCDate(r.getUTCDate() - e * 7), r;
}
var cn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 100), l(f(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "I":
          return C(k.week, e);
        case "Io":
          return i.ordinalNumber(e, {
            unit: "week"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 1 && o <= 53;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return ie(un(e, i));
    }
  }]), r;
}(T), ln = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], fn = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], dn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 90), l(f(a), "subPriority", 1), l(f(a), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "d":
          return C(k.date, e);
        case "do":
          return i.ordinalNumber(e, {
            unit: "date"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      var i = e.getUTCFullYear(), s = yt(i), u = e.getUTCMonth();
      return s ? o >= 1 && o <= fn[u] : o >= 1 && o <= ln[u];
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCDate(i), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), vn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 90), l(f(a), "subpriority", 1), l(f(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "D":
        case "DD":
          return C(k.dayOfYear, e);
        case "Do":
          return i.ordinalNumber(e, {
            unit: "date"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      var i = e.getUTCFullYear(), s = yt(i);
      return s ? o >= 1 && o <= 366 : o >= 1 && o <= 365;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCMonth(0, i), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T);
function Ae(t, n, r) {
  var a, e, o, i, s, u, c, v;
  M(2, arguments);
  var d = re(), h = W((a = (e = (o = (i = r == null ? void 0 : r.weekStartsOn) !== null && i !== void 0 ? i : r == null || (s = r.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && o !== void 0 ? o : d.weekStartsOn) !== null && e !== void 0 ? e : (c = d.locale) === null || c === void 0 || (v = c.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m = b(t), D = W(n), I = m.getUTCDay(), N = D % 7, R = (N + 7) % 7, U = (R < h ? 7 : 0) + D - I;
  return m.setUTCDate(m.getUTCDate() + U), m;
}
var mn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 90), l(f(a), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "E":
        case "EE":
        case "EEE":
          return i.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return i.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return i.day(e, {
            width: "wide",
            context: "formatting"
          }) || i.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 6;
    }
  }, {
    key: "set",
    value: function(e, o, i, s) {
      return e = Ae(e, i, s), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), hn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 90), l(f(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i, s) {
      var u = function(v) {
        var d = Math.floor((v - 1) / 7) * 7;
        return (v + s.weekStartsOn + 6) % 7 + d;
      };
      switch (o) {
        case "e":
        case "ee":
          return E(O(o.length, e), u);
        case "eo":
          return E(i.ordinalNumber(e, {
            unit: "day"
          }), u);
        case "eee":
          return i.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return i.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return i.day(e, {
            width: "wide",
            context: "formatting"
          }) || i.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 6;
    }
  }, {
    key: "set",
    value: function(e, o, i, s) {
      return e = Ae(e, i, s), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), pn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 90), l(f(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i, s) {
      var u = function(v) {
        var d = Math.floor((v - 1) / 7) * 7;
        return (v + s.weekStartsOn + 6) % 7 + d;
      };
      switch (o) {
        case "c":
        case "cc":
          return E(O(o.length, e), u);
        case "co":
          return E(i.ordinalNumber(e, {
            unit: "day"
          }), u);
        case "ccc":
          return i.day(e, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(e, {
            width: "short",
            context: "standalone"
          }) || i.day(e, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return i.day(e, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return i.day(e, {
            width: "short",
            context: "standalone"
          }) || i.day(e, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return i.day(e, {
            width: "wide",
            context: "standalone"
          }) || i.day(e, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(e, {
            width: "short",
            context: "standalone"
          }) || i.day(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 6;
    }
  }, {
    key: "set",
    value: function(e, o, i, s) {
      return e = Ae(e, i, s), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T);
function wn(t, n) {
  M(2, arguments);
  var r = W(n);
  r % 7 === 0 && (r = r - 7);
  var a = 1, e = b(t), o = e.getUTCDay(), i = r % 7, s = (i + 7) % 7, u = (s < a ? 7 : 0) + r - o;
  return e.setUTCDate(e.getUTCDate() + u), e;
}
var gn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 90), l(f(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      var s = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (o) {
        case "i":
        case "ii":
          return O(o.length, e);
        case "io":
          return i.ordinalNumber(e, {
            unit: "day"
          });
        case "iii":
          return E(i.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiii":
          return E(i.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiiii":
          return E(i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiii":
        default:
          return E(i.day(e, {
            width: "wide",
            context: "formatting"
          }) || i.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 1 && o <= 7;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e = wn(e, i), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), yn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 80), l(f(a), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "a":
        case "aa":
        case "aaa":
          return i.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return i.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCHours(Ie(i), 0, 0, 0), e;
    }
  }]), r;
}(T), bn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 80), l(f(a), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "b":
        case "bb":
        case "bbb":
          return i.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return i.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCHours(Ie(i), 0, 0, 0), e;
    }
  }]), r;
}(T), Tn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 80), l(f(a), "incompatibleTokens", ["a", "b", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "B":
        case "BB":
        case "BBB":
          return i.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return i.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCHours(Ie(i), 0, 0, 0), e;
    }
  }]), r;
}(T), xn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 70), l(f(a), "incompatibleTokens", ["H", "K", "k", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "h":
          return C(k.hour12h, e);
        case "ho":
          return i.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 1 && o <= 12;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      var s = e.getUTCHours() >= 12;
      return s && i < 12 ? e.setUTCHours(i + 12, 0, 0, 0) : !s && i === 12 ? e.setUTCHours(0, 0, 0, 0) : e.setUTCHours(i, 0, 0, 0), e;
    }
  }]), r;
}(T), Mn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 70), l(f(a), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "H":
          return C(k.hour23h, e);
        case "Ho":
          return i.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 23;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCHours(i, 0, 0, 0), e;
    }
  }]), r;
}(T), Dn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 70), l(f(a), "incompatibleTokens", ["h", "H", "k", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "K":
          return C(k.hour11h, e);
        case "Ko":
          return i.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 11;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      var s = e.getUTCHours() >= 12;
      return s && i < 12 ? e.setUTCHours(i + 12, 0, 0, 0) : e.setUTCHours(i, 0, 0, 0), e;
    }
  }]), r;
}(T), Pn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 70), l(f(a), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "k":
          return C(k.hour24h, e);
        case "ko":
          return i.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 1 && o <= 24;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      var s = i <= 24 ? i % 24 : i;
      return e.setUTCHours(s, 0, 0, 0), e;
    }
  }]), r;
}(T), Cn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 60), l(f(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "m":
          return C(k.minute, e);
        case "mo":
          return i.ordinalNumber(e, {
            unit: "minute"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 59;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCMinutes(i, 0, 0), e;
    }
  }]), r;
}(T), On = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 50), l(f(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "s":
          return C(k.second, e);
        case "so":
          return i.ordinalNumber(e, {
            unit: "second"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 59;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCSeconds(i, 0), e;
    }
  }]), r;
}(T), kn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 30), l(f(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o) {
      var i = function(u) {
        return Math.floor(u * Math.pow(10, -o.length + 3));
      };
      return E(O(o.length, e), i);
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCMilliseconds(i), e;
    }
  }]), r;
}(T), En = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 10), l(f(a), "incompatibleTokens", ["t", "T", "x"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o) {
      switch (o) {
        case "X":
          return F(q.basicOptionalMinutes, e);
        case "XX":
          return F(q.basic, e);
        case "XXXX":
          return F(q.basicOptionalSeconds, e);
        case "XXXXX":
          return F(q.extendedOptionalSeconds, e);
        case "XXX":
        default:
          return F(q.extended, e);
      }
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return o.timestampIsSet ? e : new Date(e.getTime() - i);
    }
  }]), r;
}(T), Un = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 10), l(f(a), "incompatibleTokens", ["t", "T", "X"]), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e, o) {
      switch (o) {
        case "x":
          return F(q.basicOptionalMinutes, e);
        case "xx":
          return F(q.basic, e);
        case "xxxx":
          return F(q.basicOptionalSeconds, e);
        case "xxxxx":
          return F(q.extendedOptionalSeconds, e);
        case "xxx":
        default:
          return F(q.extended, e);
      }
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return o.timestampIsSet ? e : new Date(e.getTime() - i);
    }
  }]), r;
}(T), _n = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 40), l(f(a), "incompatibleTokens", "*"), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e) {
      return wt(e);
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return [new Date(i * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(T), Yn = /* @__PURE__ */ function(t) {
  g(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 20), l(f(a), "incompatibleTokens", "*"), a;
  }
  return w(r, [{
    key: "parse",
    value: function(e) {
      return wt(e);
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return [new Date(i), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(T), Nn = {
  G: new Vr(),
  y: new Kr(),
  Y: new Zr(),
  R: new Jr(),
  u: new en(),
  Q: new tn(),
  q: new rn(),
  M: new nn(),
  L: new an(),
  w: new sn(),
  I: new cn(),
  d: new dn(),
  D: new vn(),
  E: new mn(),
  e: new hn(),
  c: new pn(),
  i: new gn(),
  a: new yn(),
  b: new bn(),
  B: new Tn(),
  h: new xn(),
  H: new Mn(),
  K: new Dn(),
  k: new Pn(),
  m: new Cn(),
  s: new On(),
  S: new kn(),
  X: new En(),
  x: new Un(),
  t: new _n(),
  T: new Yn()
}, In = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, An = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Wn = /^'([^]*?)'?$/, Ln = /''/g, $n = /\S/, Hn = /[a-zA-Z]/;
function Rn(t, n, r, a) {
  var e, o, i, s, u, c, v, d, h, m, D, I, N, R;
  M(3, arguments);
  var U = String(t), A = String(n), S = re(), X = (e = (o = void 0) !== null && o !== void 0 ? o : S.locale) !== null && e !== void 0 ? e : _e;
  if (!X.match)
    throw new RangeError("locale must contain match property");
  var G = W((i = (s = (u = (c = void 0) !== null && c !== void 0 ? c : void 0) !== null && u !== void 0 ? u : S.firstWeekContainsDate) !== null && s !== void 0 ? s : (v = S.locale) === null || v === void 0 || (d = v.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(G >= 1 && G <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var oe = W((h = (m = (D = (I = void 0) !== null && I !== void 0 ? I : void 0) !== null && D !== void 0 ? D : S.weekStartsOn) !== null && m !== void 0 ? m : (N = S.locale) === null || N === void 0 || (R = N.options) === null || R === void 0 ? void 0 : R.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(oe >= 0 && oe <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (A === "")
    return U === "" ? b(r) : /* @__PURE__ */ new Date(NaN);
  var se = {
    firstWeekContainsDate: G,
    weekStartsOn: oe,
    locale: X
  }, ue = [new zr()], Te = A.match(An).map(function(_) {
    var P = _[0];
    if (P in Pe) {
      var H = Pe[P];
      return H(_, X.formatLong);
    }
    return _;
  }).join("").match(In), Y = [], L = Ve(Te), Z;
  try {
    var xt = function() {
      var P = Z.value;
      !(a != null && a.useAdditionalWeekYearTokens) && ct(P) && we(P, A, t), !(a != null && a.useAdditionalDayOfYearTokens) && ut(P) && we(P, A, t);
      var H = P[0], me = Nn[H];
      if (me) {
        var Re = me.incompatibleTokens;
        if (Array.isArray(Re)) {
          var qe = Y.find(function(Fe) {
            return Re.includes(Fe.token) || Fe.token === H;
          });
          if (qe)
            throw new RangeError("The format string mustn't contain `".concat(qe.fullToken, "` and `").concat(P, "` at the same time"));
        } else if (me.incompatibleTokens === "*" && Y.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(P, "` and any other token at the same time"));
        Y.push({
          token: H,
          fullToken: P
        });
        var Me = me.run(U, P, X.match, se);
        if (!Me)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        ue.push(Me.setter), U = Me.rest;
      } else {
        if (H.match(Hn))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + H + "`");
        if (P === "''" ? P = "'" : H === "'" && (P = qn(P)), U.indexOf(P) === 0)
          U = U.slice(P.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (L.s(); !(Z = L.n()).done; ) {
      var We = xt();
      if (j(We) === "object") return We.v;
    }
  } catch (_) {
    L.e(_);
  } finally {
    L.f();
  }
  if (U.length > 0 && $n.test(U))
    return /* @__PURE__ */ new Date(NaN);
  var Mt = ue.map(function(_) {
    return _.priority;
  }).sort(function(_, P) {
    return P - _;
  }).filter(function(_, P, H) {
    return H.indexOf(_) === P;
  }).map(function(_) {
    return ue.filter(function(P) {
      return P.priority === _;
    }).sort(function(P, H) {
      return H.subPriority - P.subPriority;
    });
  }).map(function(_) {
    return _[0];
  }), xe = b(r);
  if (isNaN(xe.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var ce = nt(xe, pe(xe)), Le = {}, de = Ve(Mt), $e;
  try {
    for (de.s(); !($e = de.n()).done; ) {
      var He = $e.value;
      if (!He.validate(ce, se))
        return /* @__PURE__ */ new Date(NaN);
      var ve = He.set(ce, Le, se);
      Array.isArray(ve) ? (ce = ve[0], Ne(Le, ve[1])) : ce = ve;
    }
  } catch (_) {
    de.e(_);
  } finally {
    de.f();
  }
  return ce;
}
function qn(t) {
  return t.match(Wn)[1].replace(Ln, "'");
}
function Ka(t, n = /([8-9]|1\d|2[0-9]|3[01]) days|month|months|year|years/, r = "MM/dd/yyyy") {
  const a = Fr(t.getTime(), /* @__PURE__ */ new Date(), {
    addSuffix: !0
  }).replace(/about/, "").replace(/less than a minute ago/, "Just now").replace(/1 minute ago/, "Just now").replace(/1 day ago/, "Yesterday").trim();
  return a.match(n) ? Ye(t, r) : a;
}
function Za(t = "MM/dd/yyyy") {
  return Ye(/* @__PURE__ */ new Date(), t);
}
var Fn = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, Sn = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Qn = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, jn = {
  date: ae({
    formats: Fn,
    defaultWidth: "full"
  }),
  time: ae({
    formats: Sn,
    defaultWidth: "full"
  }),
  dateTime: ae({
    formats: Qn,
    defaultWidth: "full"
  })
}, Bn = {
  code: "en-GB",
  formatDistance: lt,
  formatLong: jn,
  formatRelative: ft,
  localize: dt,
  match: vt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Xn = {
  lastWeek: "'Last' eeee",
  yesterday: "'Yesterday'",
  today: "'Today'",
  tomorrow: "'Tomorrow'",
  nextWeek: "'Next' eeee",
  other: "MM/dd/yyyy"
}, Ja = {
  ...Bn,
  formatRelative: (t) => Xn[t]
}, ei = (t) => {
  console.log("Error handled by mutation", { error: t });
}, ti = (t, n, r) => t === 1 ? n : r, ri = (t) => t === !0 ? "Yes" : t === !1 ? "No" : "", ni = (t) => {
  var n, r;
  return !!((n = t == null ? void 0 : t.draft) != null && n[0]) && !((r = t == null ? void 0 : t.message) != null && r.some(
    (a) => {
      var e;
      return ((e = a.status) == null ? void 0 : e.toLowerCase()) !== "draft";
    }
  ));
};
function ai(t) {
  if (t === void 0 || t === "")
    return { keyword: void 0, isValid: !0 };
  const n = t.trim();
  return {
    keyword: n,
    isValid: n.length >= 3
  };
}
const Gn = (t) => ({ label: t, value: t }), ii = (t) => t == null ? void 0 : t.split(",").filter((n) => !!n).map(Gn), oi = (t) => !t || !Array.isArray(t) ? [] : t == null ? void 0 : t.map((n) => n == null ? void 0 : n.value);
let zn = { data: "" }, Vn = (t) => typeof window == "object" ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), { innerHTML: " ", id: "_goober" })).firstChild : t || zn, Kn = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, Zn = /\/\*[^]*?\*\/|  +/g, Ke = /\n+/g, V = (t, n) => {
  let r = "", a = "", e = "";
  for (let o in t) {
    let i = t[o];
    o[0] == "@" ? o[1] == "i" ? r = o + " " + i + ";" : a += o[1] == "f" ? V(i, o) : o + "{" + V(i, o[1] == "k" ? "" : n) + "}" : typeof i == "object" ? a += V(i, n ? n.replace(/([^,])+/g, (s) => o.replace(/(^:.*)|([^,])+/g, (u) => /&/.test(u) ? u.replace(/&/g, s) : s ? s + " " + u : u)) : o) : i != null && (o = /^--/.test(o) ? o : o.replace(/[A-Z]/g, "-$&").toLowerCase(), e += V.p ? V.p(o, i) : o + ":" + i + ";");
  }
  return r + (n && e ? n + "{" + e + "}" : e) + a;
}, Q = {}, bt = (t) => {
  if (typeof t == "object") {
    let n = "";
    for (let r in t) n += r + bt(t[r]);
    return n;
  }
  return t;
}, Jn = (t, n, r, a, e) => {
  let o = bt(t), i = Q[o] || (Q[o] = ((u) => {
    let c = 0, v = 11;
    for (; c < u.length; ) v = 101 * v + u.charCodeAt(c++) >>> 0;
    return "go" + v;
  })(o));
  if (!Q[i]) {
    let u = o !== t ? t : ((c) => {
      let v, d, h = [{}];
      for (; v = Kn.exec(c.replace(Zn, "")); ) v[4] ? h.shift() : v[3] ? (d = v[3].replace(Ke, " ").trim(), h.unshift(h[0][d] = h[0][d] || {})) : h[0][v[1]] = v[2].replace(Ke, " ").trim();
      return h[0];
    })(t);
    Q[i] = V(e ? { ["@keyframes " + i]: u } : u, r ? "" : "." + i);
  }
  let s = r && Q.g ? Q.g : null;
  return r && (Q.g = Q[i]), ((u, c, v, d) => {
    d ? c.data = c.data.replace(d, u) : c.data.indexOf(u) === -1 && (c.data = v ? u + c.data : c.data + u);
  })(Q[i], n, a, s), i;
}, ea = (t, n, r) => t.reduce((a, e, o) => {
  let i = n[o];
  if (i && i.call) {
    let s = i(r), u = s && s.props && s.props.className || /^go/.test(s) && s;
    i = u ? "." + u : s && typeof s == "object" ? s.props ? "" : V(s, "") : s === !1 ? "" : s;
  }
  return a + e + (i ?? "");
}, "");
function be(t) {
  let n = this || {}, r = t.call ? t(n.p) : t;
  return Jn(r.unshift ? r.raw ? ea(r, [].slice.call(arguments, 1), n.p) : r.reduce((a, e) => Object.assign(a, e && e.call ? e(n.p) : e), {}) : r, Vn(n.target), n.g, n.o, n.k);
}
let Tt, Oe, ke;
be.bind({ g: 1 });
let B = be.bind({ k: 1 });
function ta(t, n, r, a) {
  V.p = n, Tt = t, Oe = r, ke = a;
}
function K(t, n) {
  let r = this || {};
  return function() {
    let a = arguments;
    function e(o, i) {
      let s = Object.assign({}, o), u = s.className || e.className;
      r.p = Object.assign({ theme: Oe && Oe() }, s), r.o = / *go\d+/.test(u), s.className = be.apply(r, a) + (u ? " " + u : "");
      let c = t;
      return t[0] && (c = s.as || t, delete s.as), ke && c[0] && ke(s), Tt(c, s);
    }
    return e;
  };
}
var ra = (t) => typeof t == "function", na = (t, n) => ra(t) ? t(n) : t, aa = /* @__PURE__ */ (() => {
  let t;
  return () => {
    if (t === void 0 && typeof window < "u") {
      let n = matchMedia("(prefers-reduced-motion: reduce)");
      t = !n || n.matches;
    }
    return t;
  };
})(), ia = B`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, oa = B`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, sa = B`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, ua = K("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(t) => t.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${ia} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${oa} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(t) => t.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${sa} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`, ca = B`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, la = K("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(t) => t.secondary || "#e0e0e0"};
  border-right-color: ${(t) => t.primary || "#616161"};
  animation: ${ca} 1s linear infinite;
`, fa = B`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, da = B`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, va = K("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(t) => t.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${fa} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${da} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(t) => t.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`, ma = K("div")`
  position: absolute;
`, ha = K("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, pa = B`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, wa = K("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${pa} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, ga = ({ toast: t }) => {
  let { icon: n, type: r, iconTheme: a } = t;
  return n !== void 0 ? typeof n == "string" ? $.createElement(wa, null, n) : n : r === "blank" ? null : $.createElement(ha, null, $.createElement(la, { ...a }), r !== "loading" && $.createElement(ma, null, r === "error" ? $.createElement(ua, { ...a }) : $.createElement(va, { ...a })));
}, ya = (t) => `
0% {transform: translate3d(0,${t * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, ba = (t) => `
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${t * -150}%,-1px) scale(.6); opacity:0;}
`, Ta = "0%{opacity:0;} 100%{opacity:1;}", xa = "0%{opacity:1;} 100%{opacity:0;}", Ma = K("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, Da = K("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, Pa = (t, n) => {
  let r = t.includes("top") ? 1 : -1, [a, e] = aa() ? [Ta, xa] : [ya(r), ba(r)];
  return { animation: n ? `${B(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${B(e)} 0.4s forwards cubic-bezier(.06,.71,.55,1)` };
};
$.memo(({ toast: t, position: n, style: r, children: a }) => {
  let e = t.height ? Pa(t.position || n || "top-center", t.visible) : { opacity: 0 }, o = $.createElement(ga, { toast: t }), i = $.createElement(Da, { ...t.ariaProps }, na(t.message, t));
  return $.createElement(Ma, { className: t.className, style: { ...e, ...r, ...t.style } }, typeof a == "function" ? a({ icon: o, message: i }) : $.createElement($.Fragment, null, o, i));
});
ta($.createElement);
be`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`;
function si(t) {
  const n = t.type ? ` (${t.type})` : "";
  return `Could not upload ${t.name} because it is not a supported file type${n}.`;
}
const ui = ({
  dateString: t,
  inputFormat: n = "yyyy-MM-dd",
  outputFormat: r = "MM/dd/yyyy",
  defaultPlaceholder: a = ""
}) => {
  if (!t)
    return a;
  const e = Rn(t, n, /* @__PURE__ */ new Date());
  return Ye(e, r);
};
function ci(t, ...n) {
  return (r) => n.reduce(
    (a, e) => a.replace(/:[^/]+/, `${r[e]}`),
    t
  );
}
const li = (t) => {
  var r;
  return ((r = (Array.from(t)[0] === "/" ? t : `/${t}`).split("/")) == null ? void 0 : r[1]) || "";
};
function fi(t) {
  const n = tt();
  return ee(() => {
    n.current = t;
  }), n.current;
}
const Ze = (t) => {
  t.preventDefault();
  const n = "Leave Site? Changes you made may not be saved.";
  return t.returnValue = n, n;
}, di = (t) => {
  ee(() => (t && window.addEventListener("beforeunload", Ze), () => {
    window.removeEventListener("beforeunload", Ze);
  }), [t]);
}, vi = (t) => {
  const [n, r] = rt();
  return ee(() => {
    t != null && t.current && r(t == null ? void 0 : t.current.getBoundingClientRect());
  }, [r, t]), n;
}, mi = (t, n, r = !0) => {
  ee(() => {
    if (!n || !r)
      return;
    const a = setTimeout(t, n);
    return () => {
      clearTimeout(a);
    };
  }, [t, n, r]);
}, Je = (t, n, r) => ({
  value: t,
  timestamp: (/* @__PURE__ */ new Date()).getTime(),
  duration: n,
  elapsedDuration: r
}), et = ({
  value: t,
  duration: n,
  elapsedDuration: r,
  timestamp: a
}) => {
  const e = typeof n == "function" ? n(t) : n;
  if (r) {
    const o = (/* @__PURE__ */ new Date()).getTime() - a;
    return Math.max(e - o, 0);
  }
  return e;
}, hi = (t, {
  duration: n = 500,
  skipLapsed: r = !0,
  elapsedDuration: a = !0
} = {}) => {
  const e = tt(), [o, i] = rt([
    Je(t, n, a)
  ]), s = o[0], u = s == null ? void 0 : s.value, c = Dt(() => {
    i((v) => {
      if (v.length === 1)
        return v;
      const d = v.slice(1);
      if (!d[1])
        return d;
      if (r)
        return d.slice(-1);
      const m = d[0], D = et({
        ...m,
        elapsedDuration: m.elapsedDuration && d.length === 1
      });
      return D > 0 ? (e.current = setTimeout(c, D), d) : (d.shift(), d);
    });
  }, [r]);
  return ee(() => {
    i((v) => {
      const d = [...v], h = Je(
        t,
        n,
        a
      );
      if (d[d.length - 1].value === t)
        return v;
      if (d.push(h), v.length > 1)
        return d;
      const m = et(s);
      return m > 0 ? (e.current = setTimeout(c, m), d) : [h];
    });
  }, [t]), ee(() => () => {
    clearTimeout(e.current);
  }, []), u;
};
function pi(t) {
  ee(t, []);
}
const wi = (t, n = []) => {
  const r = Object.fromEntries(t);
  n.forEach((a) => {
    delete r[a];
  });
  for (const [a, e] of Object.entries(r))
    if (e === "true" && (r[a] = !0), e === "false" && (r[a] = !1), typeof e == "string" && !["true", "false"].includes(e)) {
      const o = Number(e);
      isNaN(o) || (r[a] = o);
    }
  return r;
}, gi = (t, n) => {
  var a, e;
  return (((e = (a = t == null ? void 0 : t.response) == null ? void 0 : a.data) == null ? void 0 : e.errors) || []).some((o) => o.type === n);
}, yi = (t) => t.map((n) => n.message).join(", ");
export {
  Ct as DEFAULT_ERROR_MESSAGE,
  Ot as capitalize,
  La as capitalizeAndSingularize,
  gi as containsErrorOfType,
  wi as convertQueryStringToObject,
  Na as copyCurrentUrlToClipboard,
  Je as createStateQueueItem,
  Ia as createStorageUtil,
  Wa as defaultErrorParser,
  Pt as defaultPrecisionResolver,
  ja as downloadPreviewFile,
  ei as errorHandledByMutation,
  $a as escapeHtml,
  Xa as formatAiContent,
  za as formatPercent,
  ui as formatStringDate,
  si as formatUnsupportedFileMessage,
  et as getDeferredValueTimeout,
  li as getFirstUrlElementFromLink,
  ri as getIsTextingAllowedLabel,
  Ea as getScrollValue,
  oi as getValuesFromRichOptions,
  ni as isDraftOnlyThread,
  Qa as isPreviewableCsv,
  Sa as isPreviewableImage,
  Ja as locale,
  Za as makeFormattedToday,
  Gn as makeRichOption,
  ii as makeRichOptionsFromCSV,
  ci as makeRouteParamsFn,
  Ha as newLinesHtml,
  ai as normalizeMessageSearchKeyword,
  Yt as parseAmount,
  qa as parseBytesToKBString,
  Va as parseCentsToDollars,
  Fa as parseFileName,
  yi as parseValidationErrors,
  ti as pluralLabel,
  Ya as preventBubbling,
  Aa as readableBytes,
  Ba as redactRequestUrl,
  kt as savePreviewBlob,
  _a as scrollToElement,
  Ua as setScrollValue,
  Ka as timeAgo,
  Ra as titleCase,
  di as useBeforeUnload,
  vi as useClientBoundingRect,
  pi as useEffectOnce,
  fi as usePrevious,
  mi as useTimeout,
  hi as useTimeoutValue,
  ka as validatePassword,
  Ga as wholePercent
};
